<template>
  <VueSidePanel
    v-model="isSidePanelOpen"
    transition-name="slide-left"
    width="60%"
    side="left"
    body-class="bbSidePanelBody"
    :z-index="5000"
  >
    <template #default>
      <div class="mt-2 px-4">
        <RaceCard
          :race="race"
          :raceNames="raceNames"
        />
      </div>
    </template>
  </VueSidePanel>
</template>
        
<script>
import RaceCard from "./RaceCard.vue";
import { VueSidePanel } from "vue3-side-panel";
import "vue3-side-panel/dist/vue3-side-panel.css";
//----------------------
// scripts
//----------------------
export default {
  name: "RaceSidePanel",
  //----------------------
  // components
  //----------------------
  components: {
    VueSidePanel,
    RaceCard,
  },
  //----------------------
  // props
  //----------------------
  props: {
    race: {
      type: Object,
      required: false,
      default: null,
    },
    raceNames: {
      type: Array,
      required: true,
      default: null,
    },
  },
  //----------------------
  // data
  //----------------------
  data() {
    return {
      isSidePanelOpen: true,
    };
  },
  //----------------------
  // computed
  //----------------------
  watch: {
    isSidePanelOpen(newValue) {
      if (!newValue) {
        this.emitter.emit("close-race-side-panel", false);
      }
    },
  },
  //----------------------
  // mounted
  //----------------------
  mounted() {
    this.emitter.on("close-race-side-panel", (ind) => {
      this.isSidePanelOpen = ind;
    });
  },
};
</script>